<!-- @format -->

<sis-responsibility-info
  *ngFor="let responsibilityInfo of visibleResponsibilityInfos$ | async"
  [responsibilityInfo]="responsibilityInfo"
  [showInactiveResponsibilities]="showInactiveResponsibilities"
  [showResponsibilityValidityPeriod]="showResponsibilityValidityPeriod">
</sis-responsibility-info>
